export class InfantClub {
	clubName: string;
	minAndMaxAge: string;
	activitiesDescription: string;

	constructor(
		clubName: string,
		minAndMaxAge: string,
		activitiesDescription: string
	) {
		(this.clubName = clubName), (this.minAndMaxAge = minAndMaxAge);
		this.activitiesDescription = activitiesDescription;
	}
}
